import { Component } from "@angular/core";

@Component({
  selector: "download-icon-svg",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="downloadIcon" viewBox="0 0 14 14" fill="none">
        <path
          d="M4.70312 6.01562L7 8.3125L9.29688 6.01562"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 2.1875V8.3125"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8125 8.3125V11.375C11.8125 11.491 11.7664 11.6023 11.6844 11.6844C11.6023 11.7664 11.491 11.8125 11.375 11.8125H2.625C2.50897 11.8125 2.39769 11.7664 2.31564 11.6844C2.23359 11.6023 2.1875 11.491 2.1875 11.375V8.3125"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
    </svg>
  `,
})
export class DownloadIconSvgComponent {}
